import React from "react";
import { createRoot } from "react-dom/client";
import { toast } from "react-toastify";
import { QueryClientProvider } from "@tanstack/react-query";
// ROOT APP
import App from "./app/App";
import { queryClient } from "./app/queryClient";

import "./styles/app/app.scss";

const showBackendDownToast = () => {
  toast.error(
    "Le serveur est indisponible pour le moment. Vérifiez qu'il est démarré puis réessayez.",
    { autoClose: 5000 }
  );
};

// Global handler for unhandled promise rejections (e.g., backend down)
// Use capture phase so we can stop React's dev overlay from handling it.
window.addEventListener("unhandledrejection", (event) => {
  const reason = event?.reason;

  // Detect Axios network errors (no response = backend not reachable)
  const isAxiosNetworkError =
    reason &&
    !reason.response &&
    (reason.isAxiosError ||
      reason.code === "ERR_NETWORK" ||
      (typeof reason.message === "string" &&
        reason.message.toLowerCase().includes("network")));

  if (isAxiosNetworkError) {
    // Prevent default unhandled rejection behavior and React error overlay
    event.preventDefault();
    event.stopImmediatePropagation();

    // eslint-disable-next-line no-console
    console.error("Backend unreachable (unhandledrejection):", reason);

    showBackendDownToast();
  }
});

// Global handler for uncaught errors bubbling to window (fallback)
// Use capture phase to short-circuit other listeners (like CRA overlay).
window.addEventListener("error", (event) => {
  const err = event?.error;

  const isAxiosNetworkError =
    err &&
    !err.response &&
    (err.isAxiosError ||
      err.code === "ERR_NETWORK" ||
      (typeof err.message === "string" &&
        err.message.toLowerCase().includes("network")));

  if (isAxiosNetworkError) {
    // Prevent React dev overlay default behavior for this specific case
    event.preventDefault();
    event.stopImmediatePropagation();

    // eslint-disable-next-line no-console
    console.error("Backend unreachable (error event):", err);

    showBackendDownToast();
  }
}, true);

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
